<template>
  <div class="userManagement" style="margin-top: 10px;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col>
        <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
          <el-tab-pane label="User List" name="userList">
           <!-- <el-form  ref="queryFrom" :model="queryFrom" class="queryFromClass">
              <el-form-item label="Login Name" prop="loginName">
                <el-input v-model="queryFrom.loginName"></el-input>
              </el-form-item>
              <el-form-item label="User Name" prop="userName">
                <el-input v-model="queryFrom.userName"></el-input>
              </el-form-item>
              <el-form-item label="Organization" prop="organization">
                <el-input v-model="queryFrom.organization"></el-input>
              </el-form-item>
              <el-form-item label="Tel" prop="tel">
                <el-input v-model="queryFrom.tel"></el-input>
              </el-form-item>
              <div align="right">
                <el-button align="right" v-on:click="searchForm('queryFrom')" type="primary">Search</el-button>
                <el-button align="right" v-on:click="resetForm('queryFrom')" type="info" plain>Reset</el-button>
              </div>
            </el-form>
            <el-button  align="right" v-on:click="addNewUser" type="primary">Add New User</el-button>
          -->
            <el-table v-loading="pieLoading"
              :data="tableData.length != 0 ? tableData.filter(data => !search || data.username.toLowerCase().includes(search.toLowerCase())) : []">
              <el-table-column prop="username" label="User Name"  align="center"></el-table-column>
              <el-table-column prop="role.name" label="Role"  align="center"></el-table-column>
              <el-table-column prop="email" label="Email"  align="center"></el-table-column>
              <el-table-column prop="createTime" label="CreateTime"  align="center">
                <template  slot-scope="scope">
                  <p>{{scope.row.createTime | timefilters}}</p>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="search"  placeholder="keyword for name"/>
                </template>
                <template slot-scope="scope">
                  <el-button  title="Edit" type="primary" icon="el-icon-edit" circle  @click="handleEdit(scope.$index,scope.row)"></el-button>
                  <el-button  title="Delete" type="danger" icon="el-icon-delete" circle   @click="handleDelete(scope.$index,scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination 
              background
              layout="total,prev,pager,next"
              :total="gridData.length"
              :page-count="Math.ceil(gridData.length/pageSize)"
              :current-page.sync="currentPage"
              @current-change ="currentPageChange"
              :page-size = "pageSize">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane :label="editUserTab" name='addNewUser' :disabled = "isShowEdit">
            <addNewUser ref="addNewUserRef" v-if="isAddNewUser" 
              :isEdit =isEdit   
              @changeToList = "changeToList" 
              :editUserInfo ="editUserInfo">
            </addNewUser>
          </el-tab-pane>
        
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import addNewUser from  './addNewUserDialog'
    export default {
      name: "whiteIpList",
      components:{addNewUser},
      filters:{
        timefilters(val){
          if(val == null || val == ''){
            return ''
          }else{
            let d = new Date(val);
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() +1 ) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
            let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
            return times;
          }
        }
      },
      data(){
          return {
            iconLoading:true,
            disabled:false,
            pieLoading:false,

            pageNumber:0,
            pageSize:7,
            currentPage:1,

            gridData: [],
            keyWords:'',
            isAddNewUser:false,
            isEdit:false,
            queryFrom:{
              loginName:'',
              userName:'',
              organization:'',
              tel:''
            },
            editUserInfo:{},
            activeName:'userList',
            editUserTab:'Edit User',
            tableData:[],
            search:'',
            isShowEdit:true
          }
      },
      mounted(){
          this.query();
      },
      methods:{
        addNewUser:function(){
          this.isEdit = false;
          this.editUserTab = 'Add New User';
          this.isAddNewUser = true;
          this.activeName = 'addNewUser';
        },
        query:function () {
          this.queryFrom.loginName = '';
          this.queryFrom.userName = '';
          this.queryFrom.organization = '';
          this.queryFrom.tel = '';
          this.$axios({ 
                method:'get',
                url:'/hlsTS/hlsii/admin/getAllURInfo'
              }).then((response) => {
              this.gridData = response.data
              this.tableData = this.gridData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize);
            })
        },
        handleEdit(index,row){
          this.isShowEdit = false;
          this.isEdit = true;
          this.editUserTab = 'Edit User';
          this.activeName = 'addNewUser';
          this.isAddNewUser = true;
          this.editUserInfo = row;
        },
        handleDelete(index,row){
          this.$confirm('Confirm to delete this User?','Notice',{
            confirmButtonText:'Sure',
            cancelButtonText:'cancle',
            type:'warning',
            center:true
          }).then(()=>{
            this.$axios.get('/hlsTS/hlsii/admin/deleteUserInfo/' +  row.id).then((response) => {
                this.$message('Operation successful');
                this.query();

            })
          })
        },
        currentPageChange:function(val){
          this.currentPage = val;
          this.tableData = this.gridData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize);
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.query();

        },
        searchForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let str = '';
              if(this.queryFrom.loginName != ""){
                str+= 'loginName=' + this.queryFrom.loginName;
              }
              if(this.queryFrom.userName != ""){
                str+= '&userName=' + this.queryFrom.userName;
              }
              if(this.queryFrom.organization != ""){
                str+= '&organization=' + this.queryFrom.organization;
              }
              if(this.queryFrom.tel != ""){
                str+= '&tel=' + this.queryFrom.tel;
              }
              this.$axios.get('/hlsTS/hlsii/admin/getAllURInfo').then((response) => {
                  this.gridData = response.data;
                  this.tableData = this.gridData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize);
                })
            } else {
              console.log('error search!!');
              return false;
            }
          });
        },
        changeToList(){
          this.isShowEdit = true;
          this.isAddNewUser = false;
          this.activeName = 'userList';
          this.editUserTab = 'Edit User';
          this.editUserInfo = {};
          this.isEdit = false;
          this.query();
          setTimeout(()=>{
            this.query();
          },100)
        },
        tabClick(tab){
          if(tab.name === 'addNewUser'){
            this.isAddNewUser = true;
          }else{
            this.isAddNewUser = false;
            this.query();
          }
        }
      }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .userManagement .el-form-item__label{width:110px;}
  .userManagement .el-form-item__content{margin-left:110px}
  .userManagement .queryFromClass .el-form-item{display: inline-block;}
  .userManagement .el-select{width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/userManagement.vue